export default "/_next/static/assets/MuseoSansCondensed-300_983779b2d07c52c9e664477413c6d1e9.woff2";